export default "/images/website.svg?e367a53616db6a17c0ff325bc84e77fe";